import { TrendingDown, TrendingUp } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

import { ScorecardAnalysisData } from "../../../data/queries/coaching";
import ExampleItem from "./ExampleItem";

interface ExamplesListProps {
  examples: ScorecardAnalysisData[];
  type: "low" | "high";
}

const ExamplesList = ({ examples, type }: ExamplesListProps) => {
  const isLowScore = type === "low";
  const Icon = isLowScore ? TrendingDown : TrendingUp;
  const iconColor = isLowScore ? "error" : "success";
  const title = isLowScore ? "Low-Scoring Examples" : "High-Scoring Examples";
  const emptyMessage = `No ${isLowScore ? "low" : "high"}-scoring examples available`;

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
        <Icon color={iconColor} />
        {title}
      </Typography>
      {examples.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {emptyMessage}
        </Typography>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {examples.map((item, index) => (
            <ExampleItem key={index} item={item} index={index} type={type} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ExamplesList;
